import {
  Box,
  Button,
  Divider,
  Flex,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { MdOutlineAccessTime } from "react-icons/md";
import { MovieCardProps } from "../../@types";
import { useRouter } from "../../hooks/useRouter";
import { useState } from "react";
import GradeAWarn from "../WarningModules/gradeAWarn";
import { SHOW_BOOKING_CLOSED } from "../../constant/alertMessage";
import { getShowStatusColorScheme } from "../../constant/enums";

function MovieCardAsList({
  title,
  duration,
  grade,
  genre,
  releaseDate,
  movieShowTimes,
  showAudiName,
}: MovieCardProps) {
  const router = useRouter();
  const [modelroute, setModalRoute] = useState<string>("");
  const {
    isOpen: messageisOpen,
    onOpen: messageonOpen,
    onClose: messageonClose,
  } = useDisclosure();
  return (
    <Flex
      bg="gray.50"
      borderRadius="lg"
      border="1px solid"
      borderColor={"primary.300"}
      overflow="hidden"
      mx="auto"
      w="100%"
      justifyContent={"space-between"}
      mt={4}
      transition="all 0.3s ease-in-out"
      _hover={{
        transform: "translateY(-4px)",
        boxShadow: "xl",
        bg: "white",
      }}
      cursor="pointer"
    >
      <Stack
        direction={{
          base: "column",
          md: "row",
        }}
        justifyContent={"space-between"}
        align="center"
        spacing="2"
        w="100%"
        p={{
          base: "3",
          md: "4",
        }}
      >
        <Text
          fontSize={{
            base: "20px",
            md: "24px",
          }}
          fontWeight="bold"
          w={{
            base: "100%",
            md: "30%",
          }}
          p={{
            base: "2",
            md: "4",
          }}
          transition="color 0.2s ease"
          _hover={{
            color: "primary.500",
          }}
          noOfLines={2}
        >
          {title}
        </Text>
        <Divider
          display={{
            base: "block",
            md: "none",
          }}
          border="1px solid #CBCBCB"
          sx={{
            rounded: "full",
          }}
        />
        <Divider
          display={{
            base: "none",
            md: "block",
          }}
          orientation="vertical"
          border="1px solid #CBCBCB"
          sx={{
            rounded: "full",
          }}
        />
        <Flex
          w={{
            base: "100%",
            md: "30%",
          }}
          gap={{
            base: 4,
            md: 6,
          }}
          p={{
            base: "2",
            md: "4",
          }}
          wrap={"wrap"}
        >
          <Flex
            fontSize={{
              base: "12px",
              md: "14px",
            }}
            fontWeight={"400"}
            color={"surface.500"}
            display={"flex"}
            gap={2}
            alignItems={"center"}
            transition="transform 0.2s ease"
            _hover={{
              transform: "translateX(4px)",
            }}
          >
            <MdOutlineAccessTime fontSize={"18px"} />
            <Text>{duration}</Text>
          </Flex>
          <Flex
            fontSize={{
              base: "12px",
              md: "14px",
            }}
            fontWeight={"400"}
            color={"surface.500"}
            display={"flex"}
            gap={2}
            alignItems={"center"}
            wrap={"wrap"}
            transition="transform 0.2s ease"
            _hover={{
              transform: "translateX(4px)",
            }}
          >
            <MdOutlineAccessTime fontSize={"18px"} />
            <Text>{grade}</Text>
          </Flex>
          <Flex
            fontSize={{
              base: "12px",
              md: "14px",
            }}
            fontWeight={"400"}
            color={"surface.500"}
            display={"flex"}
            gap={2}
            alignItems={"center"}
            transition="transform 0.2s ease"
            _hover={{
              transform: "translateX(4px)",
            }}
          >
            <MdOutlineAccessTime fontSize={"18px"} />
            <Text>{genre}</Text>
          </Flex>
          <Flex
            fontSize={{
              base: "12px",
              md: "14px",
            }}
            fontWeight={"400"}
            color={"surface.500"}
            display={"flex"}
            gap={2}
            alignItems={"center"}
            transition="transform 0.2s ease"
            _hover={{
              transform: "translateX(4px)",
            }}
          >
            <MdOutlineAccessTime fontSize={"18px"} />
            <Text>Release Date: {releaseDate}</Text>
          </Flex>
        </Flex>

        <Divider
          display={{
            base: "block",
            md: "none",
          }}
          border="1px solid #CBCBCB"
          sx={{
            rounded: "full",
          }}
        />
        <Divider
          display={{
            base: "none",
            md: "block",
          }}
          orientation="vertical"
          border="1px solid #CBCBCB"
          sx={{
            rounded: "full",
          }}
        />
        <Flex
          wrap="wrap"
          mt={{
            base: "2",
            md: "4",
          }}
          gap="2"
          p={{
            base: "2",
            md: "4",
          }}
          w={{
            base: "100%",
            md: "30%",
          }}
          justifyContent={{
            base: "flex-start",
            md: "flex-start",
          }}
        >
          {movieShowTimes?.map(
            (
              {
                start_time,
                available,
                viewable,
                showLink,
                lock_web,
                show_status,
                auditorium,
              },
              index,
            ) => (
              <Box
                key={`${start_time}-${index}`}
                opacity={0}
                animation={`fadeInUp 0.3s ease-out ${index * 0.05}s forwards`}
                sx={{
                  "@keyframes fadeInUp": {
                    "0%": {
                      opacity: 0,
                      transform: "translateY(10px)",
                    },
                    "100%": {
                      opacity: 1,
                      transform: "translateY(0)",
                    },
                  },
                }}
              >
                <Button
                  colorScheme={getShowStatusColorScheme(show_status)}
                  variant="outline"
                  size="sm"
                  color="black"
                  // Locked and already-started shows stay clickable: the
                  // seat layout opens read-only.
                  isDisabled={!(viewable ?? available)}
                  opacity={
                    lock_web && (viewable ?? available) ? 0.75 : undefined
                  }
                  title={
                    lock_web && (viewable ?? available)
                      ? SHOW_BOOKING_CLOSED
                      : undefined
                  }
                  onClick={() => {
                    if (grade === "A") {
                      messageonOpen();
                      setModalRoute(showLink);
                    } else {
                      router.push(showLink);
                    }
                  }}
                  borderColor={`${getShowStatusColorScheme(show_status)}.500`}
                  fontWeight={"normal"}
                  h="auto"
                  py="0.35rem"
                  transition="all 0.2s ease-in-out"
                  _hover={{
                    transform: "translateY(-2px)",
                    boxShadow: "md",
                  }}
                  _active={{
                    transform: "scale(0.95)",
                  }}
                >
                  <Flex direction="column" align="center" gap="0">
                    {showAudiName && auditorium?.name && (
                      <Text as="span" fontSize="xs" fontWeight="normal" opacity={0.8} lineHeight="1.3">
                        {auditorium.name}
                      </Text>
                    )}
                    <Text as="span" lineHeight="1.4">{start_time}</Text>
                  </Flex>
                </Button>
              </Box>
            ),
          )}
        </Flex>
      </Stack>
      <GradeAWarn
        isOpen={messageisOpen}
        onClose={messageonClose}
        onProceed={() => router.push(modelroute)}
        modalKey={"warning_module"}
      />
    </Flex>
  );
}

export default MovieCardAsList;
